/* CaseX model filter — searchable dropdown variant.

   Visual: trigger button → opens panel with search input + checkbox list.
   AJAX: each checkbox change fires vendor's <form is="facet-form"> handler
   which does the real filtering. We just handle the UI: open/close panel,
   search-filter list, sync trigger badge + clear button state.

   See CUSTOM_SECTIONS.md for the integration pattern (data-section-id rewire,
   pubsub sync, etc.). */
(function () {
  if (window.__casexModelFilterInit) return;
  window.__casexModelFilterInit = true;

  /* ------------------- vendor facet-form integration ------------------- */

  function getMainCollectionSectionId() {
    var grid = document.getElementById('ProductGridContainer');
    if (!grid) return null;
    var sectionEl = grid.closest('[id^="shopify-section-"]');
    return sectionEl ? sectionEl.id.replace('shopify-section-', '') : null;
  }

  function rewireFormSectionIds() {
    var mainId = getMainCollectionSectionId();
    if (!mainId) return;
    document.querySelectorAll('.casex-mfdd__form').forEach(function (form) {
      form.setAttribute('data-section-id', mainId);
    });
  }

  function setupVendorPubsubSync() {
    try {
      if (window.theme && window.theme.pubsub && window.theme.pubsub.subscribe && window.theme.pubsub.PUB_SUB_EVENTS) {
        window.theme.pubsub.subscribe(window.theme.pubsub.PUB_SUB_EVENTS.facetUpdate, function () {
          setTimeout(function () {
            rewireFormSectionIds();
            document.querySelectorAll('[data-mfdd-root]').forEach(function (root) {
              syncCheckedStateFromUrl(root);
              updateUiState(root);
            });
          }, 0);
        });
      }
    } catch (e) { /* pubsub not loaded — ignore */ }
  }

  function syncCheckedStateFromUrl(root) {
    var params = new URLSearchParams(window.location.search);
    root.querySelectorAll('.casex-mfdd__input').forEach(function (cb) {
      var name = cb.getAttribute('name');
      var value = cb.getAttribute('value');
      var activeValues = params.getAll(name);
      cb.checked = activeValues.indexOf(value) !== -1;
    });
  }

  /* --------------------- ui (open/close, search) ----------------------- */

  function getElements(root) {
    return {
      trigger: root.querySelector('[data-mfdd-trigger]'),
      panel: root.querySelector('[data-mfdd-panel]'),
      search: root.querySelector('[data-mfdd-search]'),
      list: root.querySelector('[data-mfdd-list]'),
      items: root.querySelectorAll('[data-mfdd-item]'),
      empty: root.querySelector('[data-mfdd-empty]'),
      badge: root.querySelector('[data-mfdd-badge]'),
      countLabel: root.querySelector('[data-mfdd-count-label]'),
      clear: root.querySelector('[data-mfdd-clear]'),
      inputs: root.querySelectorAll('.casex-mfdd__input'),
    };
  }

  function isMobile() {
    return window.matchMedia && window.matchMedia('(max-width: 640px)').matches;
  }

  function openPanel(root) {
    var els = getElements(root);
    if (!els.panel) return;
    els.panel.removeAttribute('hidden');
    // Force a reflow before adding the class so the transition runs
    void els.panel.offsetWidth;
    els.panel.classList.add('is-open');
    els.trigger.setAttribute('aria-expanded', 'true');
    var backdrop = root.querySelector('[data-mfdd-backdrop]');
    if (backdrop) backdrop.classList.add('is-open');
    // Lock body scroll on mobile so the page behind doesn't scroll under the sheet
    if (isMobile()) {
      document.body.classList.add('casex-mfdd-locked');
    }
    // Skip auto-focus on mobile (would pop up the on-screen keyboard immediately)
    if (!isMobile()) {
      setTimeout(function () { try { els.search.focus(); } catch (e) {} }, 50);
    }
  }

  function closePanel(root) {
    var els = getElements(root);
    if (!els.panel) return;
    els.panel.classList.remove('is-open');
    els.trigger.setAttribute('aria-expanded', 'false');
    var backdrop = root.querySelector('[data-mfdd-backdrop]');
    if (backdrop) backdrop.classList.remove('is-open');
    document.body.classList.remove('casex-mfdd-locked');
    // Wait for the transition then hide so it's removed from a11y tree
    setTimeout(function () {
      if (!els.panel.classList.contains('is-open')) {
        els.panel.setAttribute('hidden', '');
      }
    }, 200);
    // Clear the search filter
    if (els.search && els.search.value) {
      els.search.value = '';
      applySearchFilter(root, '');
    }
  }

  function isOpen(root) {
    var panel = root.querySelector('[data-mfdd-panel]');
    return panel && panel.classList.contains('is-open');
  }

  function applySearchFilter(root, query) {
    var els = getElements(root);
    var q = (query || '').trim().toLowerCase();
    var anyVisible = false;
    els.items.forEach(function (item) {
      var token = item.getAttribute('data-search') || '';
      var matches = q === '' || token.indexOf(q) !== -1;
      if (matches) {
        item.removeAttribute('hidden');
        anyVisible = true;
      } else {
        item.setAttribute('hidden', '');
      }
    });
    if (els.empty) {
      if (anyVisible) {
        els.empty.setAttribute('hidden', '');
      } else {
        els.empty.removeAttribute('hidden');
      }
    }
  }

  function updateUiState(root) {
    var els = getElements(root);
    var checkedCount = 0;
    els.inputs.forEach(function (cb) { if (cb.checked) checkedCount += 1; });

    if (els.badge) {
      if (checkedCount > 0) {
        els.badge.textContent = String(checkedCount);
        els.badge.removeAttribute('hidden');
      } else {
        els.badge.setAttribute('hidden', '');
      }
    }
    if (els.countLabel) {
      els.countLabel.textContent = checkedCount > 0
        ? checkedCount + ' selected'
        : 'None selected';
    }
    if (els.clear) {
      els.clear.disabled = checkedCount === 0;
    }
  }

  function handleClearClick(root) {
    var els = getElements(root);
    var form = root.closest('form.casex-mfdd__form');
    if (!form) return;
    var hadChecked = false;
    els.inputs.forEach(function (cb) {
      if (cb.checked) {
        cb.checked = false;
        hadChecked = true;
      }
    });
    if (hadChecked) {
      form.dispatchEvent(new Event('change', { bubbles: true }));
    }
    updateUiState(root);
  }

  /* ----------------------- event wiring (delegation) ------------------- */

  document.addEventListener('click', function (e) {
    // Trigger click → toggle
    var trigger = e.target.closest('[data-mfdd-trigger]');
    if (trigger) {
      e.preventDefault();
      var root = trigger.closest('[data-mfdd-root]');
      if (!root) return;
      if (isOpen(root)) closePanel(root); else openPanel(root);
      return;
    }

    // Clear button → uncheck all & dispatch change
    var clearBtn = e.target.closest('[data-mfdd-clear]');
    if (clearBtn) {
      e.preventDefault();
      var rootForClear = clearBtn.closest('[data-mfdd-root]');
      if (rootForClear) handleClearClick(rootForClear);
      return;
    }

    // Backdrop tap (mobile) → close
    var backdrop = e.target.closest('[data-mfdd-backdrop]');
    if (backdrop) {
      var rootForBackdrop = backdrop.closest('[data-mfdd-root]');
      if (rootForBackdrop) closePanel(rootForBackdrop);
      return;
    }

    // Drag handle tap (mobile) → close
    var handle = e.target.closest('[data-mfdd-handle]');
    if (handle) {
      var rootForHandle = handle.closest('[data-mfdd-root]');
      if (rootForHandle) closePanel(rootForHandle);
      return;
    }

    // Close button tap (mobile) → close
    var closeBtn = e.target.closest('[data-mfdd-close]');
    if (closeBtn) {
      e.preventDefault();
      var rootForClose = closeBtn.closest('[data-mfdd-root]');
      if (rootForClose) closePanel(rootForClose);
      return;
    }

    // Click outside any open panel → close (desktop only; mobile uses backdrop)
    document.querySelectorAll('[data-mfdd-root]').forEach(function (root) {
      if (!isOpen(root)) return;
      if (root.contains(e.target)) return;
      closePanel(root);
    });
  });

  document.addEventListener('input', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-mfdd-search]')) {
      var root = e.target.closest('[data-mfdd-root]');
      if (root) applySearchFilter(root, e.target.value);
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('casex-mfdd__input')) {
      var root = e.target.closest('[data-mfdd-root]');
      if (root) updateUiState(root);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('[data-mfdd-root]').forEach(function (root) {
        if (isOpen(root)) {
          closePanel(root);
          var t = root.querySelector('[data-mfdd-trigger]');
          if (t) try { t.focus(); } catch (_) {}
        }
      });
    }
  });

  /* ------------------------------ init --------------------------------- */

  function init() {
    rewireFormSectionIds();
    document.querySelectorAll('[data-mfdd-root]').forEach(function (root) {
      syncCheckedStateFromUrl(root);
      updateUiState(root);
    });
    setupVendorPubsubSync();
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

  window.addEventListener('popstate', function () {
    rewireFormSectionIds();
    document.querySelectorAll('[data-mfdd-root]').forEach(function (root) {
      syncCheckedStateFromUrl(root);
      updateUiState(root);
    });
  });
})();
